module.exports = __webpack_public_path__ + "img/flurries.facd9972.svg";